// extracted by mini-css-extract-plugin
module.exports = {"client":"ClientProject-module--client--1AWif","project":"ClientProject-module--project--CIVes","reducedMargin":"ClientProject-module--reduced-margin--2MI64"};